import { ReduxAction } from 'app/redux/types';

import { AllowingPricePreference } from 'app/modules/BetSlip/constants';

// ---

export const SWITCH_ONE_CLICK_BET_ACTIVE_STATE = 'BET_SLIP:SWITCH_ONE_CLICK_BET_ACTIVE_STATE';

export type SwitchOneClickBetActiveState = ReduxAction<
  typeof SWITCH_ONE_CLICK_BET_ACTIVE_STATE, {
  value: boolean;
}>;

export const switchOneClickBetActiveState = (value: boolean): SwitchOneClickBetActiveState => ({
  type: SWITCH_ONE_CLICK_BET_ACTIVE_STATE,
  payload: { value },
});

// ---

export const SWITCH_SETTINGS_SELECT = 'BET_SLIP:SWITCH_SETTINGS_SELECT';

export type SwitchSettingsSelect = ReduxAction<
  typeof SWITCH_SETTINGS_SELECT, {
  value: boolean;
}>;

export const switchSettingsSelect = (value: boolean): SwitchSettingsSelect => ({
  type: SWITCH_SETTINGS_SELECT,
  payload: { value },
});

// ---

export const SWITCH_TO_ALLOW_PRICE_INCREASE = 'BET_SLIP:SWITCH_TO_ALLOW_PRICE_INCREASE';

export type SwitchToAllowPriceIncrease = ReduxAction<typeof SWITCH_TO_ALLOW_PRICE_INCREASE, {
  value: boolean;
}>;

export const SWITCH_TO_ALLOW_PRICE_PREFERENCE = 'BET_SLIP:SWITCH_TO_ALLOW_PRICE_PREFERENCE';

export type SwitchToAllowPricePreference = ReduxAction<typeof SWITCH_TO_ALLOW_PRICE_PREFERENCE, {
  value: AllowingPricePreference;
}>;

export const switchToAllowPricePreference = (
  value: AllowingPricePreference,
): SwitchToAllowPricePreference => ({
  type: SWITCH_TO_ALLOW_PRICE_PREFERENCE,
  payload: { value },
});
